export default __webpack_public_path__ + "static/media/pirates_dark.9cde5eb9.png";